<app-alerts />

<app-admin-banner-details-form
  [allowedLocations]="allowedLocations()"
  [fixedLocation]="location()"
  (submitClickEvent)="handleSubmitClickEvent($event)" />
